<template>
  <div class=" flex justify-between "  @click.stop>
    <p class="font-medium text-skin-secondary">Cambiar modo</p>
    <div class="text-white rounded-full flex w-55 bg-skin-gray">
      <div
        @click="toggle"
        class=" w-1/2 h-full rounded-l-full	cursor-pointer flex items-center justify-center "
      >
        <Moon
          :fill="mood == 'dark' ? '#156a92' : '#BBBBBB'"
        />
      </div>
      <div
        @click="toggle"
        class=" w-1/2 h-full rounded-r-full	rounded-r-full	flex items-center justify-center"
      >
        <Sun
          :fill="mood == 'light' ? '#156a92' : '#BBBBBB'"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Moon from "./icons/Moon.vue";
import Sun from "./icons/Sun.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    Moon,
    Sun,
  },
  data() {
    return {
      mood: localStorage.getItem("theme"),
    };
  },
  computed: {
    ...mapGetters(["OPENMODAL"]),
  },
  methods: {
    darkmode() {
      localStorage.setItem("theme", "dark");
      (this.mood = localStorage.getItem("theme")),
        document.body.classList.add("theme-dark");
    },
    lightmode() {
      localStorage.setItem("theme", "light");
      (this.mood = localStorage.getItem("theme")),
        document.body.classList.remove("theme-dark");
    },
    toggle() {
      if (localStorage.getItem("theme") === "light") {
        localStorage.setItem("theme", "dark");
        (this.mood = localStorage.getItem("theme")),
          document.body.classList.add("theme-dark");
      } else {
        localStorage.setItem("theme", "light");
        (this.mood = localStorage.getItem("theme")),
          document.body.classList.remove("theme-dark");
      }
    },
  },
};
</script>
